//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import AccountingBankCardCreateView from '@/views/Accounting/AccAccountingBankCard/AccountingBankCardCreate'
import AccountingBankCardListView from '@/views/Accounting/AccAccountingBankCard/AccountingBankCardList'
import AccountingBankCardPaymentView from '@/views/Accounting/AccAccountingBankCard/AccountingBankCardPayment'

//
export default {
    path: 'bank_payments',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'bank-card-list',
            component: AccountingBankCardListView,
        },
        {
            path: 'create',
            name: 'bank-card-create',
            component: AccountingBankCardCreateView,
            meta: {
                title: 'Agregar cartola',
            },
        },
        {
            path: 'generate_payment/:id',
            name: 'bank-card-generate',
            component: AccountingBankCardPaymentView,
            meta: {
                title: 'Generar pago desde cartola',
            },
        },
    ],
    meta: {
        title: 'Cartolas de pago',
    },
}
